import React from 'react'
import { Flex, Loader } from '@sendoutcards/quantum-design-ui'
import { useMeasurements, useSelector } from 'src/hooks'

export const CardPreviewLoader = () => {
  const { windowWidth, windowHeight } = useMeasurements()
  const isScreenTooSmall = windowWidth < 960
  const isScreenTooShort = windowHeight < 700
  const isMobile = useSelector(state => state.window.width <= 474)

  if (isScreenTooSmall) {
    // Mobile layout - vertical stacking
    return (
      <Flex flexDirection="column" alignItems="center" inset="x1">
        {/* Card image skeleton */}
        <Loader width={isMobile ? 144 : 160} height={isMobile ? 144 : 160}>
          <rect
            width={isMobile ? 144 : 160}
            height={isMobile ? 144 : 160}
            rx={8}
            ry={8}
          />
        </Loader>

        <Flex
          flexDirection="column"
          alignItems="center"
          width="100%"
          inset={{ top: 'x2' }}
        >
          {/* Title skeleton */}
          <Loader width={280} height={24}>
            <rect x={0} y={0} width={280} height={24} rx={4} ry={4} />
          </Loader>

          {/* Subtitle skeleton */}
          <Flex inset={{ top: 'x1' }}>
            <Loader width={200} height={16}>
              <rect x={0} y={0} width={200} height={16} rx={4} ry={4} />
            </Loader>
          </Flex>
        </Flex>

        {/* Send Type label skeleton */}
        <Flex inset={{ top: 'x3' }}>
          <Loader width={80} height={10}>
            <rect x={0} y={0} width={80} height={10} rx={2} ry={2} />
          </Loader>
        </Flex>

        {/* Send type options grid */}
        <Flex inset={{ top: 'x1' }}>
          <Loader width={isScreenTooSmall ? 288 : 320} height={144}>
            <rect
              x={0}
              y={0}
              width={isScreenTooSmall ? 136 : 144}
              height={64}
              rx={8}
              ry={8}
            />
            <rect
              x={isScreenTooSmall ? 152 : 168}
              y={0}
              width={isScreenTooSmall ? 136 : 144}
              height={64}
              rx={8}
              ry={8}
            />
            <rect
              x={0}
              y={80}
              width={isScreenTooSmall ? 136 : 144}
              height={64}
              rx={8}
              ry={8}
            />
            <rect
              x={isScreenTooSmall ? 152 : 168}
              y={80}
              width={isScreenTooSmall ? 136 : 144}
              height={64}
              rx={8}
              ry={8}
            />
          </Loader>
        </Flex>
      </Flex>
    )
  }

  // Desktop layout - horizontal two-column
  return (
    <Flex
      flexDirection="column"
      inset={{
        horizontal: 'x4',
        vertical: 'x2',
      }}
      rowGap="x4"
    >
      <Flex flexDirection="row" justifyContent="space-evenly" columnGap="x4">
        {/* Left column - Card image */}
        <Flex inset={{ horizontal: 'x2' }}>
          <Loader
            width={isScreenTooShort ? 100 : 272}
            height={isScreenTooShort ? 100 : 272}
          >
            <rect
              width={isScreenTooShort ? 100 : 272}
              height={isScreenTooShort ? 100 : 272}
              rx={8}
              ry={8}
            />
          </Loader>
        </Flex>

        {/* Right column - Content */}
        <Flex flexDirection="column" width="100%">
          {/* Title skeleton */}
          <Loader width={320} height={24}>
            <rect x={0} y={0} width={320} height={24} rx={4} ry={4} />
          </Loader>

          {/* Subtitle skeleton */}
          <Flex inset={{ top: 'x1' }}>
            <Loader width={240} height={16}>
              <rect x={0} y={0} width={240} height={16} rx={4} ry={4} />
            </Loader>
          </Flex>

          {/* Send Type label skeleton */}
          <Flex inset={{ top: 'x3' }}>
            <Loader width={160} height={10}>
              <rect x={0} y={0} width={160} height={10} rx={2} ry={2} />
            </Loader>
          </Flex>

          {/* Send type options grid */}
          <Flex inset={{ top: 'x1' }}>
            <Loader width={320} height={144}>
              <rect x={0} y={0} width={144} height={64} rx={8} ry={8} />
              <rect x={168} y={0} width={144} height={64} rx={8} ry={8} />
              <rect x={0} y={80} width={144} height={64} rx={8} ry={8} />
              <rect x={168} y={80} width={144} height={64} rx={8} ry={8} />
            </Loader>
          </Flex>
        </Flex>
      </Flex>

      <Flex>
        <Loader width={660} height={32}>
          <rect x={0} y={0} width={660} height={32} rx={16} ry={16} />
        </Loader>
      </Flex>
    </Flex>
  )
}
